/* import __COLOCATED_TEMPLATE__ from './range-input.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class RangeInput extends Component {
  @service intl;

  get minErrorsExist() {
    return this.args.minErrorsExist;
  }

  get maxErrorsExist() {
    return this.args.maxErrorsExist;
  }

  @action minOnValueChange(value) {
    if (this.args.item1OnValueChange) this.args.item1OnValueChange(value);

    this.onRangeChange();
  }

  @action maxOnValueChange(value) {
    if (this.args.item2OnValueChange) this.args.item2OnValueChange(value);

    this.onRangeChange();
  }

  @action onRangeChange() {
    if (this.args.onValueChange) this.args.onValueChange();
  }
}
